// js/helper/event.js
window.luteUtil = {
  rIC: function (cb) {
    if (window.requestIdleCallback) {
      requestIdleCallback(cb)
    } else if (window.requestAnimationFrame) {
      requestAnimationFrame(cb)
    } else {
      setTimeout(cb, 4)
    }
  },
  isMobile: window.innerWidth < 768,
}

function getCookie(cname) {
  let name = cname + '='
  let decodedCookie = decodeURIComponent(document.cookie)
  let ca = decodedCookie.split(';')
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i]
    while (c.charAt(0) == ' ') {
      c = c.substring(1)
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length)
    }
  }
  return ''
}

function triggerEvent(element, name, data = {}) {
  element.dispatchEvent(
    new CustomEvent(name, {
      bubbles: true,
      detail: data,
    })
  )
}
function triggerNonBubblingEvent(element, name, data = {}) {
  element.dispatchEvent(
    new CustomEvent(name, {
      bubbles: false,
      detail: data,
    })
  )
}

const imageReady = imageOrArray => {
  if (!imageOrArray) {
    return Promise.resolve()
  }
  imageOrArray = imageOrArray instanceof Element ? [imageOrArray] : Array.from(imageOrArray)
  return Promise.all(
    imageOrArray.map(image => {
      return new Promise(resolve => {
        if ((image.tagName === 'IMG' && image.complete) || !image.offsetParent) {
          setTimeout(() => {
            image.closest('motion-element')?.classList.remove('bls-loading-image')
            image.classList.remove('bls-loading-image')
            resolve()
          }, 100)
        } else {
          image.addEventListener('load', e => {
            e.currentTarget.closest('motion-element')?.classList.remove('bls-loading-image')
            e.currentTarget.classList.remove('bls-loading-image')
            resolve()
          })
        }
      })
    })
  )
}

class MotionElement extends HTMLElement {
  constructor() {
    super()
  }
  connectedCallback() {
    if (this.isHold) return
    this.preInitialize()
    if (this.dataset.noview) {
      return
    }
    if (!this.isConnected || !document.body.contains(this)) {
      setTimeout(() => {
        this.connectedCallback()
      }, 100)
      return
    }

    var _this = this
    let custom_margin = this.dataset.margin || '0px 0px -5px 0px'
    let rootElement = {}
    if (this.dataset.parent) {
      var parent = this.closest(`.${this.dataset.parent}`)
      rootElement = { root: parent }
      custom_margin = '0px 0px 0px 0px'
    }
    motion.inView(
      _this,
      async () => {
        if (!this.isInstant && this.mediaElements && this.hasAttribute('data-image')) {
          await imageReady(this.mediaElements)
        }
        setTimeout(() => {
          _this.initialize()
        }, 50)
      },
      { margin: custom_margin, ...rootElement }
    )
  }

  get isHold() {
    return this.hasAttribute('hold')
  }

  get Transition() {
    let transition = this.getAttribute('data-transition')?.split(',').map(Number)
    return transition || [0, 0, 0.3, 1]
  }

  get isInstant() {
    return this.hasAttribute('data-instantly')
  }

  get mediaElements() {
    return Array.from(this.querySelectorAll('img, iframe, svg'))
  }

  get animationType() {
    return this.dataset.motion || 'fade-up'
  }

  get animationDelay() {
    return parseInt(this.dataset.motionDelay || 0) / 1000
  }

  set animationDelay(value) {
    this.dataset.motionDelay = value
  }

  preInitialize() {
    if (this.isHold) return
    switch (this.animationType) {
      case 'fade-in':
        motion.animate(this, { opacity: 0.01 }, { duration: 0 })
        break

      case 'fade-up':
        motion.animate(this, { transform: 'translateY(2.5rem)', opacity: 0.01 }, { duration: 0 })
        break

      case 'fade-up-sm':
        motion.animate(this, { transform: 'translateY(1rem)', opacity: 0.01 }, { duration: 0 })
        break

      case 'fade-up-lg':
        motion.animate(this, { transform: 'translateY(4rem)', opacity: 0.01 }, { duration: 0 })
        break

      case 'zoom-in':
        motion.animate(this, { transform: 'scale(0.8)' }, { duration: 0 })
        break
      case 'zoom-in-lg':
        motion.animate(this, { transform: 'scale(0)' }, { duration: 0 })
        break

      case 'zoom-out':
        motion.animate(this, { transform: 'scale(1.07)' }, { duration: 0 })
        break

      case 'zoom-out-sm':
        motion.animate(this, { transform: 'scale(1.07)' }, { duration: 0 })
        break
      case 'zoom-out-lg':
        motion.animate(this, { transform: 'scale(1.07)' }, { duration: 0 })
        break
    }
  }

  async initialize() {
    if (this.isHold) return
    switch (this.animationType) {
      case 'fade-in':
        await motion.animate(
          this,
          { opacity: 1 },
          { duration: 1.5, delay: this.animationDelay, easing: this.transition }
        ).finished
        break

      case 'fade-up':
        await motion.animate(
          this,
          { transform: 'translateY(0)', opacity: 1 },
          {
            duration: 0.5,
            delay: this.animationDelay,
            easing: this.transition,
          }
        ).finished
        break

      case 'fade-up-sm':
        await motion.animate(
          this,
          { transform: 'translateY(0)', opacity: 1 },
          {
            duration: 0.3,
            delay: this.animationDelay,
            easing: this.transition,
          }
        ).finished
        break

      case 'fade-up-lg':
        await motion.animate(
          this,
          { transform: 'translateY(0)', opacity: 1 },
          {
            duration: 0.5,
            delay: this.animationDelay,
            easing: this.transition,
          }
        ).finished
        break

      case 'zoom-in':
        await motion.animate(
          this,
          { transform: 'scale(1)' },
          { duration: 1.3, delay: this.animationDelay, easing: this.transition }
        ).finished
        break

      case 'zoom-in-lg':
        await motion.animate(
          this,
          { transform: 'scale(1)' },
          { duration: 0.5, delay: this.animationDelay, easing: this.transition }
        ).finished
        break

      case 'zoom-out':
        await motion.animate(
          this,
          { transform: 'scale(1)' },
          { duration: 1.5, delay: this.animationDelay, easing: this.transition }
        ).finished
        break

      case 'zoom-out-sm':
        await motion.animate(
          this,
          { transform: 'scale(1)' },
          { duration: 1, delay: this.animationDelay, easing: this.transition }
        ).finished
        break
      case 'zoom-out-lg':
        await motion.animate(
          this,
          { transform: 'scale(1)' },
          { duration: 1, delay: this.animationDelay, easing: this.transition }
        ).finished
        break
    }
  }
  refreshAnimation() {
    this.removeAttribute('hold')
    this.preInitialize()
    setTimeout(() => {
      this.initialize()
    }, 50) // Delay a bit to make animation re init properly.
  }
}
if (!customElements.get('motion-element')) customElements.define('motion-element', MotionElement)

class CopyButton extends HTMLElement {
  constructor() {
    super()
    this.content = this.dataset.content
    this.init()
  }
  init() {
    if (this.content) {
      this.addEventListener('click', this.onClick.bind(this))
    }
  }
  onClick() {
    navigator.clipboard.writeText(this.content)
    this.classList.add('copied')
  }
}
class CopyButtonTimeout extends CopyButton {
  constructor() {
    super()
    this.content = this.dataset.content
    this.init()
  }
  init() {
    if (this.content) {
      this.addEventListener('click', this.onClick.bind(this))
    }
  }

  onClick() {
    navigator.clipboard.writeText(this.content)
    this.classList.add('copied')

    setTimeout(() => {
      this.classList.remove('copied')
    }, 2500)
  }
}
customElements.define('copy-button-timeout', CopyButtonTimeout)

const emailPattern =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

class EmailForm extends HTMLElement {
  constructor() {
    super()
    this.form = this.querySelector('form')
    this.emailEl = this.querySelector('input[type="email"]')
    this.button = this.querySelector('button')
  }
  connectedCallback() {
    this.form.addEventListener('submit', this.onClick.bind(this))
    this.emailEl.addEventListener('input', this.removeError.bind(this))
  }
  removeError() {
    const errorTips = this.querySelector('.error-tips')
    if (errorTips) errorTips.remove()
  }
  onSuccess() {
    this.successHtml = this.querySelector('#discount-code').innerHTML
    this.parentElement.innerHTML = this.successHtml
  }
  onClick(e) {
    e.preventDefault()
    const email = this.emailEl.value
    this.removeError()
    if (!email) {
      const el = document.createElement('div')
      el.classList.add('error-tips')
      el.innerText = this.dataset.errorEmpty
      this.appendChild(el)
      return
    }
    if (!emailPattern.test(email)) {
      const el = document.createElement('div')
      el.classList.add('error-tips')
      el.innerText = this.dataset.errorInvalid
      this.appendChild(el)
      return
    }

    this.onSuccess()
    fetch(`https://account.momcozy.com/api/station/activity/collectEmail?email=${email}&scene=4`)
  }
}

if (!customElements.get('email-form')) customElements.define('email-form', EmailForm)

class PopupBase extends HTMLElement {
  constructor() {
    super()
    this.customClass = this.dataset.customClass
    this.modal = null
  }

  initPopup(content, customClass) {
    this.modal = new tingle.modal({
      footer: false,
      stickyFooter: false,
      closeMethods: ['overlay', 'button', 'escape'],
      cssClass: [this.customClass, customClass],
    })
    this.modal.setContent(content)
    this.modal.open()
  }

  onClose() {
    this.modal.close()
  }
}

class PopupRules extends PopupBase {
  constructor() {
    super()
    this.popupPopupHtml = this.querySelector('#content').innerHTML
  }

  connectedCallback() {
    this.init()
  }
  disconnectedCallback() {
    if (this.modal) {
      this.modal.destroy()
      this.modal = null
    }
  }
  init() {
    if (this.popupPopupHtml) {
      this.addEventListener('click', this.onClick.bind(this))
    }
  }
  onClick() {
    if (!this.popupPopupHtml) return
    if (this.modal) {
      this.modal.open()
      return
    }
    this.initPopup(this.popupPopupHtml, 'rules-popup')
  }
}
customElements.define('popup-rules', PopupRules)

class LoadMore extends HTMLElement {
  constructor() {
    super()
    this.isMobile = window.luteUtil.isMobile
    this.handleScreen()

    this.sectionId = this.getAttribute('data-section-id')
    this.path = this.getAttribute('data-path')
    this.total = parseInt(this.getAttribute('data-total'))
    this.currentPage = 1
    this.loadMorePagination = this.querySelector('.t4s-prs-pagination')
    this.loadMoreBtn = this.loadMorePagination.querySelector('.t4s-loadmore-btn')
    this.currentPageEl = this.loadMorePagination.querySelector('[data-current-bar]')
    this.loadMoreBar = this.loadMorePagination.querySelector('.t4s-lm-bar--current')

    this.init()
  }

  handleScreen() { }

  init() {
    this.addEventListeners()
  }

  addEventListeners() {
    if (this.loadMoreBtn) {
      this.loadMoreBtn.addEventListener('click', event => {
        event.preventDefault()
        this.loadMoreProducts()
      })
    }
  }

  getSectionInnerHTML(html, selector) {
    return (
      new DOMParser().parseFromString(html, 'text/html').querySelector(`#${selector}`)?.innerHTML ||
      ''
    )
  }

  updateEvents() {
    T4SThemeSP.reinitProductGridItem()
  }
  async loadMoreProducts() {
    if (this.currentPage >= this.total) return
    try {
      this.loadMoreBtn.classList.add('is--loading')

      const response = await fetch(
        `${this.path}/page-${this.currentPage}?section_id=${this.sectionId}`
      )
      if (!response.ok) return

      const data = await response.text()
      const newProducts = this.getSectionInnerHTML(data, 'goods_list')

      if (newProducts) {
        this.querySelector('.load-more-container').insertAdjacentHTML('beforeend', newProducts)
        this.currentPage++
        this.updateEvents()
      }

      if (this.currentPage >= this.total) {
        this.loadMorePagination.remove()
      } else {
        this.currentPageEl.innerHTML = this.currentPage
        this.loadMoreBar.style.width = `${(this.currentPage / this.total) * 100}%`
      }
    } finally {
      this.loadMoreBtn.classList.remove('is--loading')
    }
  }
}
if (!customElements.get('load-more')) customElements.define('load-more', LoadMore)

class LoadMoreProduct extends LoadMore {
  constructor() {
    super()

    this.currentOffset = parseInt(
      this.getAttribute(this.isMobile ? 'data-offset-mobile' : 'data-offset')
    )
    this.loadCount =
      parseInt(this.getAttribute(this.isMobile ? 'data-load-count-mobile' : 'data-load-count')) || 6
  }

  handleScreen() {
    if (this.isMobile) {
      const pcEls = [...this.querySelectorAll('[data-pc]')]
      pcEls.forEach(el => el.remove())
    } else {
      const mobileEls = [...this.querySelectorAll('[data-mobile]')]
      mobileEls.forEach(el => el.remove())
    }
  }

  async loadMoreProducts() {
    if (this.currentOffset >= this.total) return
    try {
      this.loadMoreBtn.classList.add('is--loading')

      const response = await fetch(
        `${this.path}/offset-${this.currentOffset}|mobile-${window.luteUtil.isMobile}?section_id=${this.sectionId}`
      )
      if (!response.ok) return

      const data = await response.text()
      const newProducts = this.getSectionInnerHTML(data, 'goods_list')

      if (newProducts) {
        this.querySelector('.load-more-container').insertAdjacentHTML('beforeend', newProducts)
        this.currentOffset += this.loadCount
        this.updateEvents()
      }

      if (this.currentOffset >= this.total) {
        this.loadMorePagination.remove()
      } else {
        this.currentPageEl.innerHTML = this.currentOffset
        this.loadMoreBar.style.width = `${(this.currentOffset / this.total) * 100}%`
      }
    } finally {
      this.loadMoreBtn.classList.remove('is--loading')
    }
  }
}

if (!customElements.get('load-more-product'))
  customElements.define('load-more-product', LoadMoreProduct)

class TabsNavigation extends HTMLElement {
  constructor() {
    super()
    this.container = this.parentElement
    this.buttons = Array.from(this.querySelectorAll('.tab-button'))
    this.bindEvents()
    this.navWrapper = this.querySelector('.tabs-wrapper')
    this.scrollContainer = this.querySelector('.tabs-scroll-container')
    this.tabsWrapper = this.querySelector('.tabs-wrapper')
    this.slider = document.createElement('div')
    this.slider.classList.add('slider')
    this.navWrapper.appendChild(this.slider)
  }

  connectedCallback() {
    // 初始化时确保第一个标签是激活状态
    const firstTabId = this.buttons[0]?.dataset.tabId

    if (firstTabId) {
      this.activateTab(firstTabId, this.buttons[0])
    }
  }

  bindEvents() {
    this.buttons.forEach(button => {
      button.addEventListener('click', this.handleTabClick.bind(this))
    })
  }

  handleTabClick(event) {
    const clickedButton = event.currentTarget
    const tabId = clickedButton.dataset.tabId
    this.activateTab(tabId, clickedButton)
  }

  updateActive(button) {
    const { offsetLeft, offsetWidth } = button
    const clipLeft = offsetLeft
    const clipRight = offsetLeft + offsetWidth
    const containerOffsetWidth = this.navWrapper.offsetWidth
    const right = Number(100 - (clipRight / containerOffsetWidth) * 100).toFixed()
    const left = Number((clipLeft / containerOffsetWidth) * 100).toFixed()
    this.slider.style.clipPath = `inset(0 ${right}% 0 ${left}% round 99px)`
  }

  moveButtonToCenter(button) {
    const buttonRect = button.getBoundingClientRect()
    const containerRect = this.tabsWrapper.getBoundingClientRect()
    const scrollContainerRect = this.scrollContainer.getBoundingClientRect()
    const scrollLeft =
      buttonRect.left - containerRect.left - (scrollContainerRect.width - buttonRect.width) / 2
    this.scrollContainer.scrollTo({
      left: scrollLeft,
      behavior: 'smooth',
    })
  }

  activateTab(tabId, activeButton) {
    // 更新标签按钮状态
    this.buttons.forEach(button => {
      const isActive = button === activeButton
      button.classList.toggle('active', isActive)
      button.setAttribute('aria-selected', isActive ? 'true' : 'false')
      if (isActive) {
        this.updateActive(button)
      }
    })

    // 直接控制内容区域的显示
    const from = this.container.querySelector(`.tab-content-container.active`)
    const to = this.container.querySelector(`[data-tab-content="${tabId}"]`)
    if (from !== to) {
      from.animate(
        {
          opacity: [1, 0],
        },
        {
          duration: 250,
          easing: 'ease',
        }
      ).onfinish = () => {
        from.classList.remove('active')
        to.classList.add('active')
        to.animate(
          {
            opacity: [0, 1],
          },
          {
            duration: 250,
            easing: 'ease',
          }
        )
      }
    }
    this.moveButtonToCenter(activeButton)
    // 触发自定义事件，以便其他组件也可以响应
    this.dispatchEvent(
      new CustomEvent('tab-changed', {
        bubbles: true,
        detail: { tabId },
      })
    )
  }
}

// 注册自定义元素
customElements.define('tabs-navigation', TabsNavigation)
/**
 * 基础倒计时组件，提供简单的天、时、分、秒显示功能
 */
class BaseCountdown extends HTMLElement {
  constructor() {
    super()
    // 定时器引用，用于清除
    this.endTime = this.dataset.endTime
    this.timer = null
  }

  connectedCallback() {
    if (!this.endTime) {
      console.warn('Countdown end date and time not set')
      return
    }

    this.setEndTime(this.endTime)
  }

  setEndTime(endTime) {
    this.endTime = endTime
    this.dataset.endTime = endTime

    const res = Date.parse(endTime)
    if (isNaN(res)) {
      console.warn('Invalid date format')
      return
    }

    // 初次立即更新
    this.updateCountdown()

    // 设置每秒更新一次
    this.timer = setInterval(() => this.updateCountdown(), 1000)
  }

  disconnectedCallback() {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  }

  /**
   * 计算剩余时间
   */
  calculateRemainingTime() {
    const endDate = Date.parse(this.endTime)
    const now = Date.now()
    const diff = endDate - now

    if (diff <= 0) {
      this.timer && clearInterval(this.timer)
      return {
        isEnded: true,
        days: 0,
        hours: 0,
        fullHours: 0,
        minutes: 0,
        seconds: 0,
        milliseconds: 0,
        diff: 0,
      }
    }

    const days = Math.floor(diff / (1000 * 60 * 60 * 24))
    const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
    const fullHours = Math.floor(diff / (1000 * 60 * 60))
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60))
    const seconds = Math.floor((diff % (1000 * 60)) / 1000)

    return { isEnded: false, days, hours, fullHours, minutes, seconds, diff }
  }

  /**
   * 更新倒计时显示 - 子类需要实现此方法
   */
  updateCountdown() {
    const time = this.calculateRemainingTime()
    // 如果倒计时结束
    if (time.isEnded) {
      // 触发事件通知倒计时结束
      this.dispatchEvent(new CustomEvent('countdown-ended'))
      return
    }

    // 触发事件通知倒计时更新
    this.dispatchEvent(new CustomEvent('countdown-updated', { detail: time }))
  }
}
// 注册基础倒计时组件
customElements.define('base-countdown', BaseCountdown)

class SimpleCountdown extends BaseCountdown {
  constructor() {
    super()
    this.isFullHours = this.hasAttribute('full-hours')
    // 获取显示元素的引用
    this.daysEl = this.querySelector('[data-days]')
    this.hoursEl = this.querySelector('[data-hours]')
    this.minutesEl = this.querySelector('[data-minutes]')
    this.secondsEl = this.querySelector('[data-seconds]')
    this.updateElement()
  }

  updateElement() {
    this.addEventListener('countdown-updated', function (e) {
      this.updateDisplay(e.detail)
    })
  }

  updateDisplay(data) {
    window.luteUtil.rIC(() => {
      if (this.isFullHours) {
        if (this.hoursEl) this.hoursEl.textContent = String(data.fullHours).padStart(2, '0')
      } else {
        if (this.daysEl) this.daysEl.textContent = String(data.days).padStart(2, '0')
        if (this.hoursEl) this.hoursEl.textContent = String(data.hours).padStart(2, '0')
      }
      if (this.minutesEl) this.minutesEl.textContent = String(data.minutes).padStart(2, '0')
      if (this.secondsEl) this.secondsEl.textContent = String(data.seconds).padStart(2, '0')
    })
  }
}

customElements.define('simple-countdown', SimpleCountdown)

class DaylyCountdown extends BaseCountdown {
  constructor() {
    super()
    this.hoursEl = this.querySelector('[data-hours]')
    this.minutesEl = this.querySelector('[data-minutes]')
    this.secondsEl = this.querySelector('[data-seconds]')
    // 获取显示元素的引用
    this.tz = this.dataset.tz || 'America/New_York'
    this.getTzEndOfToday().then(res => {
      this.endTime = res
      this.setEndTime(this.endTime)
      this.updateElement()
    })
  }

  async getTzEndOfToday() {
    const nowInTZ = dayjs().tz(this.tz).endOf('day').format()
    return nowInTZ
  }

  updateElement() {
    this.addEventListener('countdown-updated', function (e) {
      this.updateDisplay(e.detail)
    })
  }

  updateDisplay(data) {
    window.luteUtil.rIC(() => {
      if (this.hoursEl) this.hoursEl.textContent = String(data.fullHours).padStart(2, '0')
      if (this.minutesEl) this.minutesEl.textContent = String(data.minutes).padStart(2, '0')
      if (this.secondsEl) this.secondsEl.textContent = String(data.seconds).padStart(2, '0')
    })
  }
}

customElements.define('dayly-countdown', DaylyCountdown)

class SwiperCarousel extends HTMLElement {
  constructor() {
    super()
    this._createFlickity()
  }
  async disconnectedCallback() {
    if (this.swiper) {
      const swiperInstance = await this.swiper
      swiperInstance.destroy()
    }
  }
  get swiperConfig() {
    return JSON.parse(this.getAttribute('swiper-config'))
  }
  get swiperInstance() {
    return this.swiper
  }
  async next() {
    ; (await this.swiperInstance).slideNext()
  }
  async previous() {
    ; (await this.swiperInstance).slidePrev()
  }
  async select(indexOrSelector) {
    ; (await this.swiperInstance).slideTo(indexOrSelector)
  }
  async setDraggable(draggable) {
    const swiperInstance = await this.swiper
    swiperInstance.params.allowTouchMove = draggable
    swiperInstance.update()
  }
  async reload() {
    const swiperInstance = await this.swiper
    swiperInstance.destroy()
    if (this.swiperConfig['cellSelector']) {
      Array.from(this.children)
        .sort((a, b) =>
          parseInt(a.getAttribute('data-original-position')) >
            parseInt(b.getAttribute('data-original-position'))
            ? 1
            : -1
        )
        .forEach(node => this.appendChild(node))
    }
    this._createFlickity()
  }
  async _createFlickity() {
    this.swiper = new Promise(async resolve => {
      const swiperInstance = new Swiper(this, {
        ...this.swiperConfig,
        on: {
          beforeInit(swiper) {
            triggerEvent(swiper.el, 'swiper:beforeInit', swiper)
          },
        },
      })
      resolve(swiperInstance)
    })
  }

  async _preloadNextImage() {
    var _a
    const swiperInstance = await this.swiper
    if (swiperInstance.selectedElement.nextElementSibling) {
      ; (_a = swiperInstance.selectedElement.nextElementSibling.querySelector('img')) == null
        ? void 0
        : _a.setAttribute('loading', 'eager')
    }
  }
}
if (!customElements.get('swiper-carousel')) customElements.define('swiper-carousel', SwiperCarousel)

let oldTip = null
function openTipDialog(tips) {
  if (oldTip) {
    document.body.removeChild(oldTip)
    oldTip = null
  }
  const tipDialog = (oldTip = document.createElement('div'))
  tipDialog.classList.add('tip-dialog')
  tipDialog.innerHTML = `<div class="tip-dialog-content">${tips}</div>`
  document.body.appendChild(tipDialog)
  setTimeout(() => {
    tipDialog.classList.add('show')
  }, 4)

  setTimeout(() => {
    if (!tipDialog) return
    tipDialog.classList.remove('show')
    setTimeout(() => {
      document.body.removeChild(tipDialog)
      oldTip = null
    }, 600)
  }, 2000)
}
window.openTipDialog = openTipDialog

class MemberHubDot extends HTMLElement {
  constructor() {
    super()
    this.isLogined = false
  }

  connectedCallback() {
    window.luteUtil.rIC(() => {
      const hasDot = getCookie('momcozy-member-hub-tag')
      if (!hasDot) {
        this.setClass()
        this.registerEvent()
      }
    })
  }

  setClass() {
    const hasDot = getCookie('momcozy-member-hub-tag')

    if (!hasDot || !this.isLogined) {
      this.classList.add('hub-dot')
    } else {
      this.classList.remove('hub-dot')
    }
  }

  registerEvent() {
    document.addEventListener(
      'visibilitychange',
      () => {
        if (document.visibilityState === 'visible') {
          this.setClass()
        }
      },
      { once: true }
    )

    // 监听body 上有没有 .momcozy-logined 类名
    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (mutation.attributeName === 'class') {
          const classList = mutation.target.classList
          this.isLogined = classList.contains('momcozy-logined')
          this.setClass()
          if (this.isLogined) {
            observer.disconnect()
            // 注销MutationObserver
            observer = null
          }
        }
      })
    })
    observer.observe(document.body, { attributes: true })
  }
}
customElements.define('member-hub-dot', MemberHubDot)

class QuicklyBuyNowButton extends HTMLElement {
  constructor() {
    super()
    document.addEventListener('DOMContentLoaded', this.init.bind(this))
  }
  init() {
    const that = this
    that.variantId = this.getAttribute('variant-id')
    $(document).on('variant:changed', function (evt) {
      const currentVariant = evt.currentVariant
      console.log('Variant changed event received in QuicklyBuyNowButton:', currentVariant)
      that.variantId = currentVariant.id
      that.setAttribute('variant-id', that.variantId)
    })
    that.setAttribute('variant-id', that.variantId)
    that.addEventListener('click', that.onClick.bind(that))
    console.log('QuicklyBuyNowButton initialized with variant ID:', this.variantId)
  }
  onClick() {
    const variantId = this.variantId
    const quantityInput = document.querySelector('input[name="quantity"][data-current-qty]')
    const quantity = quantityInput ? quantityInput.value : 1
    if (!variantId) return
    const url = `/cart/${variantId}:${quantity}`
    window.location.href = url
  }
}
customElements.define('quickly-buy-now-button', QuicklyBuyNowButton)
